import ScheduleTab from './ScheduleTab.vue';

export default ScheduleTab;
